<template>
  <!-- <v-app>
    <v-app-bar app color="red" dark dense flat>
      <v-toolbar-title>
        <v-icon small>far fa-exclamation-triangle</v-icon>&nbsp;
        รายละเอียดข้อผิดพลาด
      </v-toolbar-title>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <div class="pa-4">
        <div class="title">CODE : {{ errCode }}</div>
        <div class="subtitle-1">SUB-CODE: {{ subErrCode }}</div>
        <v-divider class="my-4"></v-divider>
        <div v-text="desc"></div>
      </div>
    </v-main>
  </v-app> -->
  <v-app>
    <v-main>
      <div class="text-center">
        <v-row class="pa-12 ma-0 align-start">
          <v-col cols="12" sm="12" md="8" lg="6">
            <h2 class="text-center mb-4 red--text">ไม่สามารถเปิดข้อสอบได้</h2>
            <div>
              <div>เนื่องจาก: เกิดข้อผิดพลาดบางประการ</div>

              <div class="text-center my-4">
                <v-btn color="error" @click="closeWebView" width="220" depressed
                  >กลับสู่คอร์สเรียน</v-btn
                >
              </div>
            </div>
          </v-col>
        </v-row>
      </div>
    </v-main>
  </v-app>
</template>

<script>
import errors from "../assets/errors.json";
export default {
  data: () => ({
    errCode: "",
    subErrCode: "",
    desc: "",
    errors: errors,
  }),
  mounted() {
    let errCodeArr = this.$route.params.code.split(".");
    this.errCode = errCodeArr[0];
    if (errCodeArr.length > 1) {
      this.subErrCode = errCodeArr[1];
    }
    const err = this.errors.find(
      (w) => w.code == this.errCode && w.subCode == this.subErrCode
    );
    this.desc = err != null ? err.desc : "";
  },
  methods: {
    closeWebView() {
      if (typeof closeExam !== "undefined") {
        closeExam.postMessage("true");
      } else {
        console.debug("not running inside a Flutter webview");
        window.opener.postMessage("close", "*");
        window.close();
      }
    },
  }
};
</script>
<style lang="scss" scoped>
.card-error {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
.box-score {
  padding: 24px;
  width: 400px;
  max-width: 100%;
  margin: 32px auto;
  background: #f5f5f5;
  border-radius: 8px;
}

.row {
  height: 100%;
  background: #f5f5f5;
}

.col-12 {
  margin: 0 auto;
  padding: 32px;
  position: relative;
  background: #ffffff;
  border-radius: 8px;
}
.v-btn--icon {
  position: absolute;
  top: 16px;
  right: 16px;
}
</style>